<ng-template #content>
    <ng-content></ng-content>
</ng-template>

<ng-container *ngIf="showBreadCrumbButton; else showBreadCrumbSpan">
	<button [matTooltip]="tooltip" class="btn-none" (click)="action.emit()">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
</ng-container>

<ng-template #showBreadCrumbSpan>
    <span>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </span>
</ng-template>

<ng-content select="[suffix]"></ng-content>
